// A profile save signs photos again. An empty cover in that payload used to
// replace the banner already on screen until the next full page load.
export function imageUrlAfterProfileSave(
    responseUrl: string | null | undefined,
    currentUrl: string | null | undefined,
): string {
    if (typeof responseUrl === 'string' && responseUrl.trim()) return responseUrl;
    if (typeof currentUrl === 'string' && currentUrl.trim()) return currentUrl;
    return '';
}
